import type { CommunityReactionType } from '../interfaces/ICommunityHub';

import likeAsset from '../../public/assets/reactions/attendin/like.svg';
import loveAsset from '../../public/assets/reactions/attendin/love.svg';
import celebrateAsset from '../../public/assets/reactions/attendin/celebrate.svg';
import insightfulAsset from '../../public/assets/reactions/attendin/insightful.svg';
import supportAsset from '../../public/assets/reactions/attendin/support.svg';
import laughingAsset from '../../public/assets/reactions/attendin/laughing.svg';

/**
 * Centralised mapping of reaction types to original AttendIn SVG assets.
 * Used across all community and personal post reaction UIs.
 */
export const REACTION_ASSETS: Record<CommunityReactionType, string> = {
    Like: likeAsset,
    Love: loveAsset,
    Celebrate: celebrateAsset,
    Insightful: insightfulAsset,
    Support: supportAsset,
    Laughing: laughingAsset,
};

/**
 * Ordered list of reaction types for pickers and summaries.
 * Maintains consistent reaction ordering across the application.
 */
export const REACTION_TYPES: CommunityReactionType[] = [
    'Love',
    'Like',
    'Celebrate',
    'Insightful',
    'Support',
    'Laughing',
];
